import { MatButton } from 'components/buttons'
import { Icon } from 'hello-design-system'

const VideoIconButton: React.FC<{
    active: boolean
    onClick: React.MouseEventHandler<HTMLButtonElement>
    disabled: boolean
}> = ({ disabled, onClick, active }) => (
    <MatButton
        id='mic-light-icon-button'
        onClick={onClick}
        variant='contained'
        disabled={disabled}
        className='secondary'
        width='40px'
        height='40px'
        borderRadius='72px'
        color={'primary'}
    >
        <Icon width={16} iconName={active ? 'VideocamRounded' : 'VideocamOffRounded'} />
    </MatButton>
)

export { VideoIconButton }
